/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientRiskMatrixMeasuresRequestDto } from '../../models/client-risk-matrix-measures-request-dto';
import { ClientRiskMatrixMeasuresResponseDto } from '../../models/client-risk-matrix-measures-response-dto';

export interface SaveMeasures$Params {
      body: ClientRiskMatrixMeasuresRequestDto
}

export function saveMeasures(http: HttpClient, rootUrl: string, params: SaveMeasures$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientRiskMatrixMeasuresResponseDto>> {
  const rb = new RequestBuilder(rootUrl, saveMeasures.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientRiskMatrixMeasuresResponseDto>;
    })
  );
}

saveMeasures.PATH = '/kyc/client-risk-matrix/measures';
